import { MutationTree } from 'vuex'
import { CoursesState } from './state'
import { Level, Course, Issue } from '../../types'

const mutations: MutationTree<CoursesState> = {
  ACTIVE_COURSES_UPDATED: (state, courses: Array<Course>) => {
    state.activeCourses = courses
  },

  CURRENT_COURSE_UPDATED: (state, course: Course) => {
    state.currentCourse = course
  },

  CURRENT_LEVELS_UPDATED: (state, level: Level) => {
    if (Array.isArray(level)) {
      state.currentLevels = []
    } else {
      state.currentLevels.push(level)
    }
  },

  COURSE_PROGRESS_UPDATED: (state, progress: object) => {
    state.currentCourseProgress = progress
  },

  COURSE_COURSE_RATING_UPDATED: (state, courseRating: object) => {
    state.courseRating = courseRating
  },

  UPDATE_ALL_ISSUES: (state, issues: Array<Issue>) => {
    state.contentIssues = issues
  },

  CURRENT_ISSUE_PAYLOAD_UPDATED: (state, payload: Issue) => {
    state.currentIssue = {
      ...state.currentIssue,
      ...payload,
    }
  },

  CURRENT_ISSUE_RESET: state => {
    state.currentIssue = {
      subject: '',
      comment: '',
      course_id: null,
      content_type: '',
      content_subtype: '',
      content_id: null,
      extra_args: {},
    }
  },

  TOGGLE_RATING_MODAL: (state, status: Boolean) => {
    state.courseRatingModalOpened = status
  },

  UPDATE_USER_STATUS_INFO: (state, payload: Object) => {
    state.currentCourse.user_status = {
      ...state.currentCourse.user_status,
      ...payload,
    }
  },
}

export default mutations
